import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { IDetailsData } from "../../Abstraction/IDetailsData";
import { details } from "../../Storage/details";
import { Container, Row, Col } from "reactstrap";
import Styles from "./styles.module.css";
import IDetailsCredits from "../../Abstraction/IDetailsCredits";
import Carousel from "../Carousel";
import { ReactComponent as LeftArrow } from "../../Assets/svg/arrow-left.svg";
import { ReactComponent as RightArrow } from "../../Assets/svg/arrow-right.svg";
import { ReactComponent as Dice } from "../../Assets/svg/dice.svg";
import Footer from "../Footer";
import aboutUsGif from "../../Assets/footer/About_us.gif";

@(withRouter as any)
export default class Details extends Component<
  {},
  { details: IDetailsData; prevId: Number; nextId: Number }
> {
  private prevDetailsId = 0;
  private nextDetailsId = 0;
  private vimeoRef = null;

  constructor(props: any) {
    super(props);

    window.scrollTo({ behavior: "auto", top: 0 });

    const {
      match: {
        params: { id },
      },
    } = this.props as any;
    const idNum = Number(id);

    this.prevDetailsId = idNum > 1 ? idNum - 1 : details.length;
    this.nextDetailsId = idNum < details.length ? idNum + 1 : 1;

    this.state = {
      details: this.getDetails(id),
      prevId: idNum > 1 ? idNum - 1 : details.length,
      nextId: idNum < details.length ? idNum + 1 : 1,
    };

    this.renderCredits = this.renderCredits.bind(this);
    this.renderTrailers = this.renderTrailers.bind(this);
    this.renderCasestudy = this.renderCasestudy.bind(this);
  }

  getDetails = (id: any) => {
    return details.filter((x: IDetailsData) => x.id === Number(id))[0];
  };

  onDiceClick = () => {
    const {
      match: {
        params: { id },
      },
    } = this.props as any;
    const generatedId = Math.round(
      Math.random() * (details.length - 1) + 1
    ).toString();
    const isSameId = generatedId === id;

    if (isSameId) {
      this.onDiceClick();
    } else {
      (this.props as any).history.push(`/details/${generatedId}`);
      window.scrollTo({ behavior: "smooth", top: 0 });
    }
  };

  onRollNextPrevClick = () => {
    window.scrollTo({ behavior: "smooth", top: 0 });
  };

  componentWillReceiveProps(nextProps: any) {
    const prevId = Number((this.props as any).match.params.id);
    const nextId = Number((nextProps as any).match.params.id);

    if (nextId !== prevId) {
      this.setState({
        details: this.getDetails(nextId),
        prevId: nextId > 1 ? nextId - 1 : details.length,
        nextId: nextId < details.length ? nextId + 1 : 1,
      });
    }
  }

  render() {
    const carousel = this.state.details.highlightsIsVideo ? (
      <Carousel videos={this.state.details.highlights} isVideo={true} />
    ) : (
      <Carousel images={this.state.details.highlights} />
    );

    return (
      <>
        <Container fluid className={Styles.container}>
          <Row noGutters>
            <Col xs="12">
              <div className={Styles.vimeoContainer}>
                <iframe
                  className={Styles.vimeoPlayer}
                  src={`https://player.vimeo.com/video/${this.state.details.movie}?title=0&byline=0&portrait=0&sidedock=0`}
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
            </Col>
          </Row>
          <Row xs="12" noGutters className={Styles.creditsTitle}>
            <Col xs="12">
              <b className={Styles.creditsTitle}>Fact Sheet</b>
            </Col>
          </Row>
          <Row xs="12" className={Styles.credits} noGutters>
            {this.renderCredits()}
          </Row>
          <Row xs="12" noGutters>
            <Col xs="12">
              <b className={Styles.storyTitle}>Story</b>
            </Col>
            <Col xs="12">
              <p className={Styles.story}>{this.state.details.story}</p>
            </Col>
          </Row>
          <Row xs="12" noGutters>
            <Col xs="12">
              <b className={Styles.highlightsTitle}>Highlights</b>
            </Col>
          </Row>
          <Row noGutters>
            <Col xs="12">{carousel}</Col>
          </Row>
          {this.renderTrailers()}
          {this.renderCasestudy()}
          <Row noGutters className={Styles.rollContainer}>
            <Col xs="4">
              <div className={Styles.rollPrev}>
                <Link
                  to={`/details/${this.state.prevId}`}
                  onClick={this.onRollNextPrevClick}
                >
                  <LeftArrow /> Previous
                </Link>
              </div>
            </Col>
            <Col xs="4">
              <div className={Styles.rollDice}>
                <span className={Styles.rollDiceText}>
                  roll the fuckin' dice
                </span>
                <Dice onClick={this.onDiceClick} />
              </div>
            </Col>
            <Col xs="4">
              <div className={Styles.rollNext}>
                <Link
                  to={`/details/${this.state.nextId}`}
                  onClick={this.onRollNextPrevClick}
                >
                  Next <RightArrow />
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
        <Footer image={this.state.details.tvImage || aboutUsGif} />
      </>
    );
  }

  renderCredits() {
    const credits = this.state.details.credits;
    const content: any[] = [];

    for (let index = 0; index < credits.length; index++) {
      const info: IDetailsCredits = credits[index];

      const col = (
        <Col xs="4" className={Styles.creditsBlock} key={`credits-${index}`}>
          <div className={Styles.creditsBlockContent}>
            <div className={Styles.creditsText}>
              <b>{info.title}</b>
              <br />
              <p>{info.text}</p>
            </div>
          </div>
        </Col>
      );

      content.push(col);
    }

    return content;
  }

  renderTrailers() {
    return (
      this.state.details.trailers &&
      this.state.details.trailers.map((trailer) => (
        <Fragment key={trailer.title}>
          <Row xs="12" noGutters className={Styles.trailerTitleContainer}>
            <Col xs="12">
              <b className={Styles.trailerTitle}>{trailer.title}</b>
            </Col>
          </Row>
          <Row xs="12" noGutters>
            <div className={Styles.trailerContainer}>
              <iframe
                className={Styles.trailerPlayer}
                src={`https://player.vimeo.com/video/${trailer.video}?title=0&byline=0&portrait=0&sidedock=0`}
                frameBorder="0"
                allowFullScreen
              />
            </div>
          </Row>
        </Fragment>
      ))
    );
  }

  renderCasestudy() {
    return this.state.details.casestudy ? (
      <>
        <Row xs="12" noGutters className={Styles.casestudyTitleContainer}>
          <Col xs="12">
            <b className={Styles.casestudyTitle}>Case study</b>
          </Col>
        </Row>
        <Row xs="12" noGutters>
          <div className={Styles.casestudyContainer}>
            <iframe
              className={Styles.casestudyPlayer}
              src={`https://player.vimeo.com/video/${this.state.details.casestudy}?title=0&byline=0&portrait=0&sidedock=0`}
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </Row>
      </>
    ) : (
      <></>
    );
  }
}
